import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../api/authApi";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!phone) {
      setError("Phone number is required");
      return;
    }

    if (!/^[0-9]{10}$/.test(phone)) {
      setError("Phone number must be 10 digits");
      return;
    }

    try {
      await forgotPassword(phone);

      // store phone for next step
      localStorage.setItem("resetPhone", phone);

      navigate("/verify-otp", { state: { flow: "forgot" } });
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-[#f4ede4]">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow">
        <h2 className="text-3xl font-semibold mb-6">Forgot Password</h2>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            type="tel"
            placeholder="Enter registered phone number"
            className="w-full border-b py-3 focus:outline-none"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <button className="w-full bg-black text-white py-3 rounded-full">
            Send OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
